import { render } from "./c_table.vue?vue&type=template&id=2c6e1749&scoped=true"
import script from "./c_table.vue?vue&type=script&lang=js"
export * from "./c_table.vue?vue&type=script&lang=js"

import "./c_table.vue?vue&type=style&index=0&id=2c6e1749&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6e1749"]])

export default __exports__